import './App.css';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Home from './pages/Home';
import HomeEN from './pages/HomeEN';
import HomeRU from './pages/HomeRU';

function App() {
  return (
    <div className="App">
      <Router>
        <div className="wrapper">
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/en' exact component={HomeEN} />
            <Route path='/ru' exact component={HomeRU} />
          </Switch>
        </div>
      </Router>
    </div>
  );
}

export default App;
